module.exports = __webpack_public_path__ + "static/img/5.d2997d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/5.png
// module id = YIt8
// module chunks = 0